// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider-container {\n  margin: 10px 0 10px;\n}\n\n.slider-container div:first-child {\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n\n.slider-container div:first-child h4 {\n  margin-right: 20px;\n  margin-bottom: 0;\n}\n\n.slider-container input[type=\"range\"] {\n  cursor: pointer;\n  accent-color: var(--light-blue);\n}\n\n.slider-container .value-container {\n  width: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
